import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { login as apiLogin, logout as apiLogout, fetchUser, fetchUserWithProfile} from '../utils/auth';




export const login = createAsyncThunk('auth/login', async (credentials, thunkAPI) => {
  const response = await apiLogin(credentials.username, credentials.password);
  // Save user to localStorage
  localStorage.setItem('authToken', response.key);

  const user = await fetchUser();
  localStorage.setItem('user', JSON.stringify(user));
  // console.dir(localStorage)

  const userWithProfile = await fetchUserWithProfile(user.pk);
  localStorage.setItem('userWithProfile', JSON.stringify(userWithProfile));
  // console.dir(localStorage)


  return response;
});

export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  await apiLogout();
  // Remove user from localStorage
  localStorage.removeItem('user');
});

const userFromLocalStorage = JSON.parse(localStorage.getItem('userWithProfile'));
// const userFromLocalStorage = null;

export const fetchUserAfterSSO = createAsyncThunk('auth/fetchUserAfterSSO', async (_, thunkAPI) => {

  console.dir("calling fetchUserAfterSSO...")
  const user = await fetchUser();
  localStorage.setItem('user', JSON.stringify(user));
  const userWithProfile = await fetchUserWithProfile(user.pk);
  localStorage.setItem('userWithProfile', JSON.stringify(userWithProfile));
  return userWithProfile;
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: userFromLocalStorage || null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
      });
  },
});

export default authSlice.reducer;
